import { tokens, BLACK_700, LILAC_200 } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getFailurePageStyles = isLargeScreen => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: LILAC_200,
      borderRadius: 16
    },
    statusCard: {
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: isLargeScreen ? 644 : '',
      padding: tokens.spacing.SPACING_20
    },
    statusCardTitle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    title: {
      paddingBottom: tokens.spacing.SPACING_8
    },
    description: {
      color: BLACK_700,
      textAlign: 'center'
    },
    detailsSection: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: tokens.spacing.SPACING_20
    },
    buttonSection: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: tokens.spacing.SPACING_16,
      paddingBottom: tokens.spacing.SPACING_20
    },
    actionCta: {
      marginRight: tokens.spacing.SPACING_18
    },
    navigateSection: Object.assign({}, isLargeScreen && {
      flexDirection: 'row'
    }),
    navigateSectionCta: Object.assign({
      paddingBottom: tokens.spacing.SPACING_8
    }, isLargeScreen && {
      paddingRight: tokens.spacing.SPACING_16
    }),
    marginBottom: {
      marginBottom: tokens.spacing.SPACING_20
    },
    offerStrip: {
      marginTop: tokens.spacing.SPACING_8,
      alignSelf: 'center'
    }
  });
};